import { render, staticRenderFns } from "./NThNationalAssemblyTable.vue?vue&type=template&id=2bf57f8e&scoped=true"
import script from "./NThNationalAssemblyTable.vue?vue&type=script&lang=js"
export * from "./NThNationalAssemblyTable.vue?vue&type=script&lang=js"
import style0 from "./NThNationalAssemblyTable.vue?vue&type=style&index=0&id=2bf57f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf57f8e",
  null
  
)

export default component.exports